function RenderHook({
  hook: useHook,
  parameters,
  children
}) {
  return children(useHook(...parameters));
}
export {
  RenderHook
};
//# sourceMappingURL=render-hook.js.map